const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/appointment/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        reasonForAppointmentText: 'Bitte geben Sie an, in welchem Bereich Sie einen Termin benötigen:',
        treatmentReasonText: 'Bereichswahl',
        choiceOfDate: 'Terminwahl',
        availableSlots: 'Verfügbare Termin-Slots:',
        appointmentReason: 'Grund für Terminanfrage',
        commentAppointmentReason: 'Bitte erläutern Sie den Grund Ihrer Terminanfrage:',
        addInformation: 'Angaben ergänzen',
        addInformationText: 'Bitte ergänzen Sie falls nötig folgende Angaben:',
        chosenDate: 'Ihr gewählter Termin',
        requestAppointment: 'Anfrage senden',
        bookAppointment: 'Termin buchen',
        confirmEintritt: 'Eintritt bestätigen',
        confirmed: 'Bestätigt',
        Cancel: 'Abbrechen',
        selectArea: 'Bereich/Ansprechpartner',
        treatmentReason: 'Behandlungsgrund',
        noTreatmentReasonAvailable: 'Keine Option verfügbar',
        chosenSlot: 'Ihr gewählter Termin: ',
        cardTitle: 'Termin buchen',
        noAvailableSlots: 'Keine Termin-Slots verfügbar',
        bookingConfirmationMessage:
            'Ihre Terminanfrage wurde versendet. Sobald diese vom Spital bestätigt wird, erhalten Sie eine Mail.',
        rescheduleConfirmationMessage: 'Ihr Termin wurde provisorisch umgebucht.',
        appointmentMutationInformation: 'Sie können den Termin bis zu 24h vorher anpassen oder stornieren.',
        myAppointments: 'Meine Termine',
        bookMoreAppointments: 'Weiterer Termin buchen',
        rescheduleAppointment: 'Termin umbuchen',
        contact: 'Standort',
        commentField: 'Bitte erlauben Sie uns der Grund für Ihre Terminanfrage etwas genauer',
        label: 'Grund',
        email: 'E-Mail',
        streetAndNumber: 'Strasse und Nr.',
        postcode: 'PLZ',
        location: 'Ort',
        country: 'Land',
        socialInsurance: 'AHV-Nr.',
        helpTitleText: 'Bitte beantworten Sie folgende Fragen:',
        helpText:
            'An welcher Körperstelle haben Sie Symptome?\nSeit wann haben Sie diese Symptome?\nGibt es ein möglichen Grund für die Symptome?',
        ahvHelpTextTitle: 'AHV-Nr.',
        ahvHelpText: 'Geben Sie Ihre 13-stellige AHV-Nummer in dieses Feld ein.',
        contactPerson: 'Bereich / Ansprechpartner',
        date: 'Datum',
        time: 'Zeit',
        cancel: 'Abbrechen',
        plzInvalidNotAllowed: 'Bitte geben Sie eine gültige Postleitzahl ein',
        timeFormat: '{time} Uhr',
        appointment: 'Termin',
        calendarEmpty: 'Sie haben keine anstehenden Termine',
        terminUmbuchen: 'Termin umbuchen',
        terminGebucht: 'Termin provisorisch gebucht',
        terminUmgebucht: 'Termin provisorisch umgebucht',
        terminUmbuchenHelpText: 'Bitte wählen Sie einen neuen Slot für Ihren Termin.',
        pastAppointmentCardTitle: 'Vergangene Termine',
        upcomingAppointmentCardTitle: 'Anstehende Termine',
    },
    __RELATIVE_SOURCE_FILE__
);
